import { render, staticRenderFns } from "./goods_combine.vue?vue&type=template&id=0dbdeeed&scoped=true"
import script from "./goods_combine.vue?vue&type=script&lang=js"
export * from "./goods_combine.vue?vue&type=script&lang=js"
import style0 from "./goods_combine.vue?vue&type=style&index=0&id=0dbdeeed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbdeeed",
  null
  
)

export default component.exports